"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var PropTypes = require('prop-types');

var React = require('react');

var _ = require('lodash');

var compose = require('../../hoc/compose');

var displayNames = require('../displayNames');

var textTypes = require('../textTypes');

var Toggle = require('../toggle');

var _Symbol = require('../switch-svg.js');

var SIZES = {
  MEDIUM: 'switch-size-medium'
};

var toggleSwitch = /*#__PURE__*/function (_React$Component) {
  _inherits(toggleSwitch, _React$Component);

  var _super = _createSuper(toggleSwitch);

  function toggleSwitch(props) {
    var _this;

    _classCallCheck(this, toggleSwitch);

    _this = _super.call(this, props);
    var className = _this.props.getClassName('control-switch') + (_this.props.animated ? ' control-switch-animated' : '') + (_this.props.size ? " ".concat(SIZES[_this.props.size]) : '') + (_this.props.widthByTextLength ? ' width-by-text-length' : '') + (_this.props.onCheck ? ' has-on-check' : '');

    _this.getToggleProps = function () {
      return _.assign({}, _this.props, {
        className: className,
        name: 'switch'
      });
    };

    _this.getLabelType = function () {
      return props.labelType.toLowerCase();
    };

    _this.pressKeyButton = function (e) {
      if (e.which === 32 || e.which === 13) {
        e.preventDefault();

        if (_this.props.onChange) {
          _this.props.onChange(!_this.props.value);
        }
      }
    };

    _this.onLabelClick = function (e) {
      if (_this.props.onCheck) {
        e.preventDefault();

        _this.props.onCheck();
      }
    };

    _this.randomFilterId = Math.random().toString(36).substring(7);
    return _this;
  }

  _createClass(toggleSwitch, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(Toggle, _.assign({}, {
        'data-aid': this.props.automationId,
        'data-hook': this.props.dataHook
      }, this.getToggleProps()), this.props.symbol ? /*#__PURE__*/React.createElement("span", {
        key: "symbol-image",
        className: "symbol-image",
        tabIndex: "0"
      }, this.props.symbol) : null, this.props.label && !this.props.labelAfterSymbol ? /*#__PURE__*/React.createElement("span", {
        className: 'label label-switch ' + this.getLabelType(),
        key: "label",
        onClick: this.onLabelClick,
        tabIndex: "0",
        "aria-checked": this.props.value
      }, this.props.translateIfNeeded(this.props.label)) : null, /*#__PURE__*/React.createElement("span", {
        role: "switch",
        "aria-checked": this.props.value,
        className: "symbol symbol-switch",
        onKeyPress: this.pressKeyButton,
        tabIndex: "0"
      }, /*#__PURE__*/React.createElement(_Symbol, {
        filterId: this.randomFilterId
      })), this.props.label && this.props.labelAfterSymbol ? /*#__PURE__*/React.createElement("span", {
        className: 'label label-switch ' + this.getLabelType(),
        key: "label",
        onClick: this.onLabelClick
      }, this.props.translateIfNeeded(this.props.label)) : null, this.props.children);
    }
  }]);

  return toggleSwitch;
}(React.Component);

toggleSwitch.displayName = displayNames.TOGGLE_SWITCH;
toggleSwitch.propTypes = {
  /** lable text to display */
  label: PropTypes.string,

  /** whether the lable should be shown before or after the toggle switch */
  labelAfterSymbol: PropTypes.bool,

  /** the lable type */
  labelType: PropTypes.oneOf(textTypes.TYPES),

  /** should animated the toggle between true or false */
  animated: PropTypes.bool,

  /** disables the toggle switch */
  disabled: PropTypes.bool,

  /** toggle value */
  value: PropTypes.bool.isRequired,

  /** a callback called with the new value when clicking on the toggle switch */
  onChange: PropTypes.func,

  /** a callback called on toggle switch to 'true' */
  onCheck: PropTypes.func,

  /** toggle size: can be default or 'MEDIUM' */
  size: PropTypes.oneOf(_.keys(SIZES)),

  /** set toggle switch width by lable text length */
  widthByTextLength: PropTypes.bool,

  /** render symbol element before toggle switch*/
  symbol: PropTypes.element
};
toggleSwitch.defaultProps = {
  labelAfterSymbol: false,
  animated: false,
  labelType: textTypes.DEFAULT_TYPE,
  widthByTextLength: false
};
module.exports = compose(toggleSwitch);
module.exports.SIZES = SIZES;